var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMap = function SvgMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1.527 5.187v6.486c0 1.267.9 1.787 1.993 1.16l1.567-.893c.34-.193.907-.213 1.26-.033l3.5 1.753c.353.173.92.16 1.26-.033l2.887-1.654c.366-.213.673-.733.673-1.16V4.327c0-1.267-.9-1.787-1.993-1.16l-1.567.893c-.34.193-.907.213-1.26.033l-3.5-1.746c-.353-.174-.92-.16-1.26.033L2.2 4.033c-.373.214-.673.734-.673 1.154M5.707 2.667v8.666M10.487 4.413v8.92"
  })));
};
export default SvgMap;